const getNativeClassNameStyle = (className, style) => {
  if (className) {
    return [className, style];
  }

  const isStyleStr = typeof style === 'string';

  return [isStyleStr ? style : undefined, isStyleStr ? undefined : style];
};

export default getNativeClassNameStyle;
